import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { UsersComponent } from './pages/users/users.component';
import { UsersRoutingModule } from './users-routing.module';
import { MaterialListModule } from '@components/material-list/material-list.module';
import { SiteListModule } from '@components/site-list/site-list.module';
import { UsersGridComponent } from './components/users-grid/users-grid.component';
import { UserDetailModule } from './components/user-detail/user-detail.module';

@NgModule({
  imports: [
    CommonModule,
    UsersRoutingModule,
    CoreModule,
    MaterialListModule,
    SiteListModule,
    UserDetailModule
  ],
  declarations: [
    UsersComponent,
    UsersGridComponent
  ]
})
export class UsersModule { }
